<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page001">
<div class="jstfy" id="page001_1">VEGAN</div>
<div class="jstfy" id="page001_2">RECIPES FROM</div>
<div class="jstfy" id="page001_3">FRANCE</div>
<div class="jstfy" id="page001_4">KRISTINA ARNOLD</div>
<div class="jstfy" id="page001_5"><span class="page001_5a">GRUB STREET</span> | <span class="page001_5a">LONDON</span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_001.vue?bca847c0